/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import Mousetrap from "./libraries/ShortcutHandling.js";
import {Subscription} from "./Subscription.js";

class Shortcuts {
    constructor() {
        this.shortcuts = []

        this.sub = new Subscription()

    }


    register(label, categoryName, shortcut, callback) {
        let categoryIndex = this.shortcuts.findIndex((item) => (item.categoryName === categoryName))

        if (categoryIndex === -1) {
            this.shortcuts.push({categoryName: categoryName, shortcuts: []})
        }
        categoryIndex = this.shortcuts.findIndex((item) => (item.categoryName === categoryName))
        this.shortcuts[categoryIndex].shortcuts.push({label: label, shortcut: shortcut})

        if (callback !== undefined) {
            this.sub.add(() => Mousetrap.bind(shortcut, callback))
        }

    }

    get() {
        return this.shortcuts
    }

    unmount() {
        this.sub.unmount()
    }

}

export {Shortcuts}